module.exports = __webpack_public_path__ + "static/media/Rogue.90f34e53.png";